import React, { useState } from "react";
import Navbar from "../../Navbar/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem,
    TextField,
    Grid,
    Card,
    CircularProgress,
    CardContent,
    Typography,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";



const CrewingEditContractTable = () => {
    const [formData, setFormData] = useState({
        crewingAgentStatus: "",
        remark: "",
        formI: null, // File upload
    });


    const [openModal, setOpenModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalDocuments, setModalDocuments] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();


    const location = useLocation();
    const { crewingAgentId, contract } = location.state || {};
    const userId = localStorage.getItem("user id");


    if (!contract) {
        return <div>Error: Contract data is missing.</div>;
    }


    const handleOpenModal = (title, docs) => {
        setModalTitle(title);
        setModalDocuments(docs);
        setOpenModal(true);
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handleFileChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            formI: e.target.files[0],
        }));
    };


    // const handleSubmit = async (e, id) => {
    //     e.preventDefault();

    //     if (loading) return; // Prevent double submission

    //     setLoading(true);
    //     const userEmail = Cookies.get("userEmail");

    //     let approvedBy = {
    //         id: userId, // make sure userId is defined somewhere
    //         name: userEmail === "admin@gmail.com" ? "Admin" : "Crewing Agent"
    //     };

    //     // const crewingAgentStatus = {
    //     //     status: formData.crewingAgentStatus, // "Approve" | "Not Approve" | "Correction"
    //     //     approvedBy
    //     // };


    //     const formDataToSend = new FormData();
    //     formDataToSend.append("crewingAgentId", crewingAgentId || id);
    //     formDataToSend.append("contractId", contract?._id);
    //     formDataToSend.append("crewingAgentStatus", formData?.crewingAgentStatus);
    //     formDataToSend.append("approvedBy", JSON.stringify(approvedBy));
    //     formDataToSend.append("remark", formData.remark);


    //     if (formData.formI) {
    //         formDataToSend.append("formI", formData.formI);
    //     }


    //     try {
    //         const token = localStorage.getItem("token");
    //         await axios.post(`${baseURL}/api/contract-status`, formDataToSend, {
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });
    //         toast.success("Contract status saved successfully!");
    //         setTimeout(() => {
    //             setLoading(false);
    //         }, 1500);
    //     } catch (error) {
    //         toast.error("Failed to save contract status!");
    //         setLoading(false);
    //     }
    //     finally {
    //         setLoading(false);
    //     }
    // };

  const handleSubmit = async (e, id) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    const userType = localStorage.getItem("userType");
    const userId = localStorage.getItem("user id");
    const token = localStorage.getItem("token");

    const approvedBy = {
        id: userId,
        name: userType
    };

    try {
        let payload;
        let headers;

        if (formData.formI) { // If a file is being sent
            payload = new FormData();
            payload.append('crewingAgentId', crewingAgentId || id);
            payload.append('contractId', contract?._id);
            payload.append('crewingAgentStatus', formData?.crewingAgentStatus || "");
            
            // Fix: Send nested objects using bracket notation for FormData
            payload.append('approvedBy[id]', userId);
            payload.append('approvedBy[name]', userType);
            
            payload.append('remark', formData?.remark || "");
            payload.append('formI', formData.formI); // actual file
            
            // Fix: Send formI_uploadedBy using bracket notation 
            payload.append('formI_uploadedBy[id]', userId);
            payload.append('formI_uploadedBy[name]', userType);

            headers = {
                // Remove Content-Type completely - let browser set it with boundary
                Authorization: `Bearer ${token}`,
            };
        } else { // No file, send JSON
            payload = {
                crewingAgentId: crewingAgentId || id,
                contractId: contract?._id,
                crewingAgentStatus: formData?.crewingAgentStatus || "",
                approvedBy: approvedBy,
                remark: formData?.remark || "",
            };

            headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };
        }

        if (formData.formI) {
            console.log("File details:", {
                name: formData.formI.name,
                size: formData.formI.size,
                type: formData.formI.type
            });
        }

        await axios.post(`${baseURL}/api/contract-status`, payload, { headers });

        toast.success("Contract status saved successfully!");
        
        // Reset form after successful submission
        setFormData({
            crewingAgentStatus: "",
            remark: "",
            formI: null,
        });
        
        // Reset file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.value = '';
        }

         setTimeout(() => {
            navigate(-1);
        }, 1500);
        
    } catch (error) {
        console.error("Error saving contract status:", error);
        console.error("Error response:", error.response?.data);
        toast.error("Failed to save contract status!");
    } finally {
        setLoading(false);
    }
};




    return (
        <>

            <Box sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Edit Contract Table
                </Typography>


                <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <strong>Sr. No.</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>Vessel Owner</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>Crew Details</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>Crewing Agent</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>1</TableCell>


                                {/* Vessel Owner Column */}
                                <TableCell>
                                    {!crewingAgentId && ( // Hide the button if crewingAgentId is present
                                        <Typography>
                                            <strong>Company:</strong>{" "}
                                            {contract.vesselOwner?.company_shortname || "N/A"}
                                        </Typography>
                                    )}
                                    <Typography>
                                        <strong>Vessel:</strong>{" "}
                                        {contract.ShipDetails?.vesselname || "N/A"}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ backgroundColor: "#B87333" }}
                                        onClick={() =>
                                            handleOpenModal(
                                                "Vessel Documents",
                                                [
                                                    // "seagreement",
                                                    // "cdagreement",
                                                    "pipolicydocument",
                                                    "maritimelabourconvention",
                                                    "fsdocument",
                                                    "dmlcp1",
                                                    "dmlc2",
                                                ].map((doc) => ({
                                                    name: doc.replace(/([A-Z])/g, " $1"),
                                                    filePath:
                                                        contract?.ShipDetails?.[doc]?.filePath || null,
                                                }))
                                            )
                                        }
                                    >
                                        View Vessel Documents
                                    </Button>
                                </TableCell>


                                {/* Crew Details Column */}
                                <TableCell>
                                    {/* {console.log("contract.crewdetails", contract.crewdetails)} */}
                                    <Typography>
                                        <strong>Name:</strong> {contract.crewdetails?.name || "N/A"}
                                    </Typography>
                                    <Typography>
                                        <strong>Indos No.:</strong>{" "}
                                        {contract.crewdetails?.indosno || "N/A"}
                                    </Typography>
                                    <Typography>
                                        <strong>Mobile No.:</strong>{" "}
                                        {contract.crewdetails?.mobile || "N/A"}
                                    </Typography>
                                    <Typography>
                                        <strong>Email:</strong>{" "}
                                        {contract.crewdetails?.email || "N/A"}
                                    </Typography>
                                    <Typography>
                                        <strong>Rank:</strong>{" "}
                                        {contract.crewdetails?.rankname || "N/A"}
                                    </Typography>


                                    {/* Button to Open Modal with Crew Documents */}
                                    <Button
                                        variant="contained"
                                        sx={{ backgroundColor: "#E53935" }}
                                        onClick={() =>
                                            handleOpenModal(
                                                "Crew Documents",
                                                [
                                                    { key: "crewDocument", label: "Crew Document" },
                                                    { key: "passportDocument", label: "Passport" },
                                                    { key: "cdcDocument", label: "CDC" },
                                                    { key: "iloDocument", label: "ILO" },
                                                    { key: "stcwDocument", label: "STCW" },
                                                    { key: "stsdsdDocument", label: "STSDSD" },
                                                    { key: "CrewPhotoDocument", label: "Crew Photo" },
                                                    { key: "yellowfeverDocument", label: "Yellow Fever" },
                                                    { key: "CovidVaccineDocument", label: "COVID Vaccine" },
                                                    { key: "watchkeepingDocument", label: "Watchkeeping" },
                                                    { key: "CopDocument", label: "COP" },
                                                    { key: "cookcocDocument", label: "Cook COC" },
                                                    { key: "officercocDocument", label: "Officer COC" },
                                                    { key: "gocDocument", label: "GOC" },
                                                    { key: "gmdssDocument", label: "GMDSS" },
                                                    { key: "h2sDocument", label: "H2S" },
                                                    { key: "huetDocument", label: "HUET" },
                                                    { key: "highvoltageDocument", label: "High Voltage" },
                                                    { key: "brmDocument", label: "BRM" },
                                                    { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
                                                    { key: "bosietDocument", label: "BOSIET" },
                                                    { key: "signContratDocument", label: "Signed Contract" },
                                                    { key: "pscrbDocument", label: "PSCRB" },
                                                    { key: "sidDocument", label: "SID" },
                                                    { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
                                                    { key: "MFA", label: "Medical First Aid (MFA)" },
                                                    { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
                                                    { key: "SSO", label: "Ship Security Officer (SSO)" },
                                                    { key: "BTM", label: "Bridge Team Management (BTM)" },
                                                    { key: "ECDIS", label: "ECDIS" },
                                                    { key: "contract", label: "Contract" },
                                                    { key: "BankDocument", label: "Bank Details" },
                                                ]
                                                    .map((doc) => ({
                                                        name: doc.label,
                                                        filePath: contract?.crewdetails?.[doc.key]?.filePath || null,
                                                    }))
                                                    .filter((doc) => doc.filePath !== null) // ✅ Only show documents with filePath
                                            )
                                        }
                                    >
                                        View Crew Documents
                                    </Button>


                                </TableCell>


                                {/* Crewing Agent Column */}
                                <TableCell>
                                    <Typography>
                                        <strong>Agent Name:</strong>{" "}
                                        {contract.crewingAgent?.agentName || "N/A"}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>


                <Card
                    sx={{
                        p: 2,
                        maxWidth: "600px",
                        mx: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >
                    <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <Grid container spacing={2}>
                            {/* Check if adminStatus is "Approve" */}
                            {console.log("contract.latestStatus", contract?.contractStatus?.latestStatus)}
                            {contract.contractStatus?.latestStatus?.crewingAgentStatus === "Approve"
                                &&
                                !contract.contractStatus?.formI
                                ? (
                                    <>
                                        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                            Please add Form I
                                        </Typography>


                                        {/* Form I Upload Field */}
                                        <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                            <Typography variant="h6">Upload Form I</Typography>
                                            <input
                                                type="file"
                                                onChange={handleFileChange}
                                                style={{ height: "35px", padding: "5px" }}
                                            />
                                        </Grid>


                                        {/* Submit Button - visible only when Form I is being uploaded */}
                                        <Grid
                                            item
                                            xs={12}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                color="success"
                                                fullWidth
                                                onClick={(e) => handleSubmit(e, contract.crewingAgent?._id)}
                                                sx={{ height: "40px" }}
                                            >
                                                {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                                            </Button>
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        {!contract.contractStatus?.formI ? (
                                            <>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sx={{ display: "flex", flexDirection: "column", width: "100%" }}
                                                >
                                                    <Typography variant="h6">Status</Typography>
                                                    <Select
                                                        name="crewingAgentStatus"
                                                        value={formData.crewingAgentStatus}
                                                        onChange={handleInputChange}
                                                        fullWidth
                                                        size="small"
                                                        displayEmpty
                                                    >
                                                        <MenuItem value="">Select Status</MenuItem>
                                                        <MenuItem value="Approve">Approved</MenuItem>
                                                        <MenuItem value="Not Approve">Not Approved</MenuItem>
                                                        <MenuItem value="Correction">Correction</MenuItem>
                                                    </Select>
                                                </Grid>


                                                {/* Remarks Input */}
                                                {formData.crewingAgentStatus && (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography variant="h6">Remarks</Typography>
                                                        <TextField
                                                            variant="outlined"
                                                            fullWidth
                                                            size="small" // Reduces input height
                                                            sx={{ height: "40px" }}
                                                            name="remark"
                                                            value={formData.remark}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Grid>
                                                )}


                                                {/* Submit Button - Only visible when !contract.latestStatus?.formI */}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Button
                                                        variant="contained"

                                                        fullWidth
                                                        onClick={(e) => handleSubmit(e, contract.crewingAgent?._id)}
                                                        sx={{ height: "40px", backgroundColor: "#B8860B" }}
                                                    >
                                                        {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                                                    </Button>
                                                </Grid>
                                            </>
                                        ) : null}
                                    </>
                                )}
                        </Grid>
                    </CardContent>
                </Card>




            </Box>


            {/* Documents Modal */}
            <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
                <DialogTitle>{modalTitle}</DialogTitle>
                <DialogContent>
                    {modalDocuments.length > 0 ? (
                        modalDocuments.map((doc, index) => (
                            <Paper
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    p: 2,
                                    mb: 2,
                                    borderRadius: "8px",
                                    boxShadow: 1,
                                }}
                            >
                                {/* Document Icon and Name */}
                                <Box display="flex" alignItems="center">
                                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                                    <Typography variant="body1">{doc.name}</Typography>
                                </Box>


                                {/* Download Button or No File Message */}
                                {doc.filePath ? (
                                    <Button
                                        variant="contained"
                                        href={doc.filePath.startsWith("http") ? doc.filePath : `${baseURL}/${doc.filePath.replace(/\\/g, "/")}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ backgroundColor: "#FFD700" }}
                                    >
                                        Download
                                    </Button>
                                ) : (
                                    <Box display="flex" alignItems="center">
                                        <ReportProblemIcon sx={{ color: "orange", mr: 1 }} />
                                        <Typography variant="body2" color="red">
                                            No File Available
                                        </Typography>
                                    </Box>
                                )}
                            </Paper>
                        ))
                    ) : (
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ py: 3 }}
                        >
                            <ReportProblemIcon sx={{ fontSize: 50, color: "orange" }} />{" "}
                            {/* No Document Icon */}
                            <Typography color="textSecondary" mt={1}>
                                No documents available
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>


            <ToastContainer />
        </>
    );
};


export default CrewingEditContractTable;

